<div class="meo-page">
  <!-- ARIA live region for recording state changes -->
  <div class="visually-hidden" aria-live="assertive" role="status">
    {{ recordingAriaStatus }}
  </div>

  <!-- Top bar -->
  <div class="meo-top-bar" [class.recording-active]="meoStore.isRecording()">
    <h2 class="meo-title">{{ ss.t('meo_title') }}</h2>
    <div class="top-bar-actions">
      <button class="icon-btn" (click)="onNewSession()"
        [attr.aria-label]="ss.t('meo_new_session')">
        <app-svg name="plusThin" height="20" width="20" [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
      </button>
      <button class="icon-btn" (click)="onGoToHistory()"
        [attr.aria-label]="ss.t('meo_history')">
        <app-svg name="clock" height="18" width="18" [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
      </button>
      <button class="icon-btn" (click)="onToggleDebug()"
        [attr.aria-label]="ss.t('meo_debugInfo')"
        [class.active]="meoStore.showDebug()">
        <app-svg name="debugIcon" height="18" width="18" [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
      </button>
      <button class="icon-btn" (click)="onClose()"
        [attr.aria-label]="ss.t('common_close')">
        <app-svg name="topBarClose" height="16" width="16" [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
      </button>
    </div>
  </div>

  <!-- Debug panel (overlay) -->
  @if (meoStore.showDebug()) {
    <div class="debug-overlay" (click)="onToggleDebug()">
      <div class="debug-panel" (click)="$event.stopPropagation()">
        <div class="debug-header">
          <h3 class="debug-title">{{ ss.t('meo_debugInfo') }}</h3>
          <button class="icon-btn" (click)="onToggleDebug()">
            <app-svg name="topBarClose" height="16" width="16" [color]="ss.theme().color8"></app-svg>
          </button>
        </div>
        <app-meo-debug [turns]="meoStore.currentSession()?.turns || []"></app-meo-debug>
      </div>
    </div>
  }

  <!-- Message thread -->
  <div class="meo-thread hide-scrollbar" #messageThread
    [class.recording-active]="meoStore.isRecording()">
    @if (meoStore.currentSession(); as session) {
      @for (turn of session.turns; track $index; let turnIdx = $index) {
        <!-- Message bubble -->
        <app-meo-message [turn]="turn"></app-meo-message>

        <!-- Suggestion cards (rendered below assistant messages) -->
        @if (turn.role === 'assistant' && turn.suggestions.length > 0) {
          @for (suggestion of turn.suggestions; track $index; let sugIdx = $index) {
            <app-meo-suggestion-card
              [suggestionMeta]="suggestion"
              [suggestionEntity]="getSuggestionEntity(turnIdx, sugIdx)"
              (confirmed)="onConfirmSuggestion(turnIdx, sugIdx)"
              (dismissed)="onDismissSuggestion(turnIdx, sugIdx)"
            ></app-meo-suggestion-card>
          }
        }
      }

      <!-- Thinking indicator -->
      @if (meoStore.isLoading()) {
        <div class="thinking-indicator">
          <div class="thinking-bubble">
            <div class="thinking-dot"></div>
            <div class="thinking-dot"></div>
            <div class="thinking-dot"></div>
          </div>
        </div>
      }
    }

    <!-- Empty state -->
    @if (!meoStore.currentSession() || meoStore.currentSession()!.turns.length === 0) {
      @if (!meoStore.isLoading()) {
        <div class="empty-state">
          <div class="empty-state-icon">
            <app-svg name="meoSparkle" height="44" width="44" [color]="ss.theme().color35"></app-svg>
          </div>
          <h3 class="empty-state-title">{{ ss.t('meo_how_can_i_help') }}</h3>
          <div class="suggestion-chips">
            <button class="suggestion-chip" (click)="onMessageSent(ss.t('meo_suggestion_habit'))">
              {{ ss.t('meo_suggestion_habit') }}
            </button>
            <button class="suggestion-chip" (click)="onMessageSent(ss.t('meo_suggestion_money'))">
              {{ ss.t('meo_suggestion_money') }}
            </button>
            <button class="suggestion-chip" (click)="onMessageSent(ss.t('meo_suggestion_todo'))">
              {{ ss.t('meo_suggestion_todo') }}
            </button>
            <button class="suggestion-chip" (click)="onDiscoverMore()">
              {{ ss.t('meo_discover_more') }}
            </button>
          </div>
        </div>
      }
    }
  </div>

  <!-- Audio recording overlay -->
  <app-meo-audio
    #audioRecorder
    (audioReady)="onAudioReady($event)"
    (cancelled)="onAudioCancelled()"
  ></app-meo-audio>

  <!-- Input bar (hidden during voice recording) -->
  @if (!isVoiceMode || !meoStore.isRecording()) {
    <app-meo-input
      #inputBar
      [isLoading]="meoStore.isLoading()"
      [isMeoUploading]="meoStore.isMeoUploading()"
      (messageSent)="onMessageSent($event)"
      (messageWithAttachment)="onMessageWithAttachment($event)"
      (micPressed)="onMicPressed()"
    ></app-meo-input>
  }
</div>
